module.exports = __webpack_public_path__ + "static/media/ward-icon-illuminated.bdf9c2cc.svg";